import { HTTPService, httpService } from "../core/services/http.service"
import { NewsDO } from "./news.data"

export class NewsService {

  constructor(private httpService: HTTPService) {
  }

  async load(query?: string | null, tokens?: string | null, title?: string | null, k?: string | null, min_score?: string | null): Promise<NewsDO[]> {
    const params = new URLSearchParams()

    params.set('top_k', k?.toString() ?? '100')
    params.set('min_score', min_score?.toString() ?? '0')

    if (query) params.set('query', query)
    if (tokens) params.set('tokens', tokens)
    if (title) params.set('title', title)

    return await this.httpService.query(`articles?${params}`, "GET")
  }
}

export const newsService = new NewsService(httpService)